<!-- #63 -->
<template>
  <v-col class="mx-3">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        {{ this.$route.query.id > 0 ? "Update" : "Upload" }}
        {{ fainalText }}
        Mapping
      </div>

      <v-spacer> </v-spacer>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>

    <v-card>
      <v-card-title>
        <span class="body-1 font-weight-bold"
          >{{ this.$route.query.id > 0 ? "Update" : "Upload" }}
          <span v-if="this.$route.query.id > 0">- {{ token_number }}</span>

          <i class="caption red--text ml-4"> * required field</i>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form ref="form">
          <v-row v-if="this.$route.query.id > 0">
            <v-col cols="12" sm="4" md="4" class="pb-0">
              <v-text-field
                label="Warehouse"
                v-model="wms_warehouse_code"
                disabled
                outlined
                hide-details
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pb-0">
              <v-text-field
                label="Actual Warehouse"
                v-model="actual_warehouse"
                disabled
                outlined
                hide-details
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pb-0">
              <v-text-field
                label="Storer"
                v-model="storer_name"
                disabled
                outlined
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <div
              class="text-h6 py-0 my-0 pl-3 mt-1 mb-1"
              style="color: #23468c; font-weight: 500; font-size: 14px"
              v-if="type == 'Inbound' || type == 'Both'"
            >
              Inbound
            </div>
            <br />
            <v-data-table
              v-if="type == 'Inbound' || type == 'Both'"
              :headers="headers"
              :items="inboundOrder"
              :loading="inboundOrderLoader"
              class="elevation-1 custom-icon-size ml-3"
              hide-default-footer
              disable-pagination
              style="width: 100%"
            >
              <template v-slot:[`item.stages_status`]="{ item }">
                <span
                  @click="openStageMessage(item)"
                  v-if="item.stages_status == 'Failed'"
                  ><a>{{ item.stages_status }}</a></span
                >
                <span v-else>{{ item.stages_status }}</span>
              </template>

              <template v-slot:[`item.receipt_key`]="{ item }">
                <a
                  ><span @click="findSummary(item.inbound_id, item, true)">{{
                    item.receipt_key
                  }}</span></a
                >
                <br />
                <span v-if="item.receipt_no">({{ item.receipt_no }})</span>
              </template>

              <template v-slot:[`item.created_at`]="{ item }">
                <span v-if="item.created_at">{{
                  item.created_at | uaeDateTime | moment("DD MMM, YYYY hh:mm A")
                }}</span
                ><br /><span v-if="item.created_by"
                  >({{ item.created_by }})</span
                >
              </template>
              <template v-slot:[`item.updated_at`]="{ item }">
                <span v-if="item.updated_at">{{
                  item.updated_at | uaeDateTime | moment("DD MMM, YYYY hh:mm A")
                }}</span>

                <br /><span v-if="item.updated_by"
                  >({{ item.updated_by }})</span
                >
              </template>
              <template v-slot:[`item.PUTAWAY_COMPLETED_QTY`]="{ item }">
                {{ getData(item, "PUTAWAY_COMPLETED_QTY") }}
              </template>
              <template v-slot:[`item.RECEIVED_QTY`]="{ item }">
                {{ getData(item, "RECEIVED_QTY") }}
              </template>
              <template v-slot:[`item.EXPECTED_QTY`]="{ item }">
                {{ getData(item, "EXPECTED_QTY") }}
              </template>
              <template v-slot:[`item.DAMAGE_QTY`]="{ item }">
                {{ getData(item, "DAMAGE_QTY") }}
              </template>
              <template v-slot:[`item.oms_order_date_time`]="{ item }">
                <span v-if="item.oms_order_date_time">{{
                  item.oms_order_date_time
                    | localMoment
                    | moment("DD MMM, YYYY hh:mm A")
                }}</span>
              </template>

              <template v-slot:[`item.client_name`]="{ item }">
                {{ item.client_name }}
                <span v-if="item.storer_key">({{ item.storer_key }})</span>
              </template>
              <template v-slot:[`item.shipping_address_country`]="{ item }">
                <label>
                  {{ item.shipping_address_country }}
                </label>
              </template>
            </v-data-table>
            <div
              class="text-h6 py-0 my-0 pl-3 mt-1 mb-1"
              v-if="type == 'Outbound' || type == 'Both'"
              style="color: #23468c; font-weight: 500; font-size: 14px"
            >
              Outbound
            </div>
            <br />
            <v-data-table
              v-if="type == 'Outbound' || type == 'Both'"
              :headers="headersOutbound"
              :items="OutboundOrder"
              :loading="OutboundOrderLoader"
              class="elevation-1 custom-icon-size ml-3"
              hide-default-footer
              disable-pagination
              style="width: 100%"
            >
              <template v-slot:[`item.created_at`]="{ item }">
                <span v-if="item.created_at">{{
                  item.created_at | uaeDateTime | moment("DD MMM, YYYY hh:mm A")
                }}</span>
                <br /><span v-if="item.created_by"
                  >({{ item.created_by }})</span
                >
              </template>
              <template v-slot:[`item.client_name`]="{ item }">
                {{ item.client_name }} <br /><span v-if="item.storer_key"
                  >({{ item.storer_key }})</span
                ></template
              >
              <template v-slot:[`item.order_key`]="{ item }">
                <a @click="findSummaryOutbound(item.outbound_id, item, true)">{{
                  item.order_key
                }}</a>

                <br />
                <span v-if="item.receipt_no">({{ item.receipt_no }})</span>
              </template>

              <template v-slot:[`item.updated_at`]="{ item }">
                <span v-if="item.updated_at">{{
                  item.updated_at | uaeDateTime | moment("DD MMM, YYYY hh:mm A")
                }}</span>

                <br /><span v-if="item.updated_by"
                  >({{ item.updated_by }})</span
                >
              </template>

              <template v-slot:[`item.shipped_qty`]="{ item }">
                {{ getDataootbound(item, "shipped_qty") }}
              </template>
              <template v-slot:[`item.allocated_qty`]="{ item }">
                {{ getDataootbound(item, "allocated_qty") }}
              </template>
              <template v-slot:[`item.picked_qty`]="{ item }">
                {{ getDataootbound(item, "picked_qty") }}
              </template>

              <template v-slot:[`item.order_qty`]="{ item }">
                {{ getDataootbound(item, "order_qty") }}
              </template>
              <template v-slot:[`item.expected_qty`]="{ item }">
                {{ getDataootbound(item, "expected_qty") }}
              </template>
            </v-data-table>

            <v-col md="4" class="custom pb-0">
              <v-file-input
                v-model="file"
                counter
                show-size
                accept=".xlsx"
                class="required"
                prepend-icon=""
                prepend-inner-icon="mdi-paperclip"
                label="Upload File"
                outlined
                dense
                :rules="[(v) => !!v || 'Please Upload File']"
              >
              </v-file-input>
            </v-col>
          </v-row>

          <v-row v-else>
            <v-col cols="12" sm="6" md="6" class="pb-0">
              <v-autocomplete
                label="Select Warehouse"
                :items="warehousees"
                v-model="wms_warehouse_code"
                :rules="[(v) => !!v || 'Warehouse is required.']"
                class="required pb-0"
                hide-details="auto"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col md="6" class="custom pb-0">
              <v-file-input
                v-model="file"
                counter
                show-size
                accept=".xlsx"
                class="required"
                prepend-icon=""
                prepend-inner-icon="mdi-paperclip"
                label="Upload File"
                outlined
                :rules="[(v) => !!v || 'Please Upload File']"
              >
              </v-file-input>
            </v-col>
          </v-row>
          <v-row class="text-left mt-4" :class="{ 'mt-0': !editable }">
            <v-col class="">
              <v-btn color="primary" dark :loading="fileLoader" @click="save">
                {{ this.$route.query.id > 0 ? "Update" : "Upload" }}
              </v-btn>
              <v-btn
                color="info"
                class="ml-3"
                :loading="downloader"
                @click="downloadTemplate()"
                >Download template</v-btn
              >

              <v-btn class="ml-3" @click="close()"> Cancel </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <BulkErrors
      :dialog="uploadResDialog"
      :data="uploadRes"
      @close="uploadResDialog = false"
      file-name="Projection-Errorlist"
      :other="other"
    />
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
import BulkErrors from "@/components/front/common/BulkErrors";

export default {
  components: {
    BulkErrors,
  },
  data: () => ({
    fainalText: "Inbound Outbound",
    inboundOrder: [],
    OutboundOrder: [],
    headersOutbound: [
      {
        text: "Order Number (#External No)",
        value: "order_key",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Type",
        value: "type",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Status",
        value: "status",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Allocated Status Qty",
        value: "allocated_qty",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Picked Status Qty",
        value: "picked_qty",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Shipped Qty",
        value: "shipped_qty",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Delivery Date",
        value: "delivery_date",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Created At (By)",
        value: "created_at",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Updated At (By)",
        value: "updated_at",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
    ],
    headers: [
      {
        text: "ASN / Receipt (External Key)",
        value: "receipt_key",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: "150px",
      },

      {
        text: "ASN / Receipt Type",
        value: "type",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "ASN / Receipt Status",
        value: "status",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Expected Qty",
        value: "EXPECTED_QTY",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Received Qty",
        value: "RECEIVED_QTY",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Rejected Qty",
        value: "DAMAGE_QTY",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Putaway Qty (Pending)",
        value: "PUTAWAY_COMPLETED_QTY",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Created At (By)",
        value: "created_at",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Updated At (By)",
        value: "updated_at",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
    ],
    statuses: [
      { text: "Active", value: 1 },
      { text: "Inactive", value: 0 },
    ],
    status: null,
    uploadRes: {},
    uploadResDialog: false,
    deliveryDate: false,
    fileLoader: false,
    reasonList: "",
    required: false,
    tokenDetails: {},
    warehousees: [],
    dateMenu: false,
    date: null,
    file: null,
    wms_warehouse_code: null,
    pallet_number: null,
    quantity: null,
    storers: [],
    vehicles: [],
    storer_name: null,
    purposes: [
      {
        text: "Inbound",
        value: 1,
      },
      {
        text: "Outbound",
        value: 2,
      },
      {
        text: "Both",
        value: 3,
      },
    ],
    no_of_vehicle: null,
    vehicle_type: null,
    purpose: null,
    token_number: null,
    actual_warehouse: null,
    type: null,
    tableDetailsItems: [],
  }),

  async created() {
    await this.fetchStore();
    if (this.$route.query.id > 0) {
      this.callAPi();
    }
  },
  computed: {},
  methods: {
    ...mapActions([
      "fetchStorelist",
      "downloadProjectionTemplate",
      "uploadProjectionMapping",
      "snackBar",
      "getPasUserList",
      "getProjectionMappingDetails",
      "updateProjectionMapping",
    ]),
    findSummary(id) {
      window.open(
        this.$router.resolve({
          name: "InboundListView",
          query: {
            id: id,
          },
        }).href,
        "_blank"
      );
    },
    findSummaryOutbound(item) {
      window.open(
        this.$router.resolve({
          name: "OutboundListView",
          query: {
            id: item.id,
          },
        }).href,
        "_blank"
      );
    },
    getDataootbound(e, type) {
      let searchKey = e.order_key;
      if (this.tableDetailsItemsOutbound.length > 0) {
        let result = this.tableDetailsItems.find(
          (item) => item.ORDERKEY === searchKey
        );
        if (result !== undefined && result !== null && result !== "") {
          if (type == "allocated_qty") {
            return this.changeNumberFormat(result.QTY_IN_ALLOCATED_STATUS);
          } else if (type == "pre_allocated_qty") {
            return this.changeNumberFormat(result.pre_allocated_qty);
          } else if (type == "open_qty") {
            return this.changeNumberFormat(result.open_qty);
          } else if (type == "order_qty") {
            return this.changeNumberFormat(result.order_qty);
          } else if (type == "shipped_qty") {
            return this.changeNumberFormat(result.SHIPPED_QTY);
          } else if (type == "picked_qty") {
            return this.changeNumberFormat(result.QTY_IN_PICKED_STATUS);
          } else {
            return "--";
          }
        } else {
          return "--";
        }
      } else {
        return "--";
      }
    },
    callAPi() {
      this.getProjectionMappingDetails(this.$route.query.id).then((res) => {
        this.wms_warehouse_code = res.data.warehouse_name;
        this.actual_warehouse = res.data.actual_warehouse;
        this.storer_name = res.data.storer_name;
        this.inboundOrder = res.data.inbound;
        this.tableDetailsItems = res.data.inbound_infor;
        this.OutboundOrder = res.data.outbound;
        this.tableDetailsItemsOutbound = res.data.outbound_infor;
        this.token_number = res.data.token_number;
        this.type = res.data.token_type;
        if (this.type == "Inbound") {
          this.fainalText = "Inbound";
        } else if (this.type == "Outbound") {
          this.fainalText = "Outbound";
        } else if (this.type == "Both") {
          this.fainalText = "Inbound Outbound";
        }
      });
    },
    getData(e, type) {
      let searchKey = e.receipt_key;
      if (this.tableDetailsItems.length > 0) {
        let result = this.tableDetailsItems.find(
          (item) => item.RECEIPTKEY === searchKey
        );
        if (result !== undefined && result !== null && result !== "") {
          if (type == "PUTAWAY_COMPLETED_QTY") {
            return (
              this.changeNumberFormat(result.PUTAWAY_COMPLETED_QTY) +
              " (" +
              this.changeNumberFormat(result.PUTAWAY_PENDING_QTY) +
              ")"
            );
          } else if (type == "RECEIVED_QTY") {
            return this.changeNumberFormat(result.RECEIVED_QTY);
          } else if (type == "EXPECTED_QTY") {
            return this.changeNumberFormat(result.EXPECTED_QTY);
          } else if (type == "DAMAGE_QTY") {
            return this.changeNumberFormat(result.DAMAGE_QTY);
          } else {
            return "--";
          }
        } else {
          return "--";
        }
      } else {
        return "--";
      }
    },
    async fetchStore() {
      await this.fetchStorelist().then((res) => {
        this.storers = res.data.storer;
        this.warehousees = res.data.warehouses.map(
          (obj) => Object.keys(obj)[0]
        );
        this.vehicles = res.data.vehicle_types;
      });
    },
    downloadTemplate() {
      this.downloader = true;
      var url;
      if (this.$route.query.id > 0) {
        url = `/api/file_download?file_path=app_pas/pas_templates/pas_inbound_outbound_mapping_update.xlsx`;
      } else {
        url = `/api/file_download?file_path=app_pas/pas_templates/pas_inbound_outbound_mapping.xlsx`;
      }

      this.downloadProjectionTemplate(url)
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },
    close() {
      this.$refs.form.reset();
      this.$router.go(-1);
    },
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.fileLoader = true;
      const payload = new FormData();
      let warehouse = this.wms_warehouse_code;
      if (this.$route.query.id > 0) {
        warehouse = this.actual_warehouse;
      }
      payload.append("warehouse_name", warehouse);
      payload.append("data_file", this.file, this.file.name);

      if (this.$route.query.id > 0) {
        let payloaddata = {
          id: this.$route.query.id,
          data: payload,
        };
        this.updateProjectionMapping(payloaddata)
          .then((res) => {
            this.fileLoader = false;
            this.file = null;

            if (res.data.with_error) {
              this.uploadRes = res.data;
              this.uploadResDialog = true;
            } else {
              this.snackBar({
                color: "success",
                message: res.data.message,
              });
              // this.$router.push("/pasProjectionMapping");
            }
            this.callAPi();
          })
          .catch(() => {
            this.fileLoader = false;
          });
      } else {
        payload.append("data_file", this.file, this.file.name);
        this.uploadProjectionMapping(payload)
          .then((res) => {
            this.fileLoader = false;

            this.$refs.form.reset();
            this.date = null;
            if (res.data.with_error) {
              this.uploadRes = res.data;
              this.uploadResDialog = true;
            } else {
              this.snackBar({
                color: "success",
                message: res.data.message,
              });
              this.$router.push("/pasProjectionMapping");
            }
          })
          .catch(() => {
            this.fileLoader = false;
          });
      }
    },
  },
};
</script>
